export class UserData {

    constructor(public name?: string,
        public surname?: string,
        public address?: string,
        public email?: string,
        public telephone?: string,
        public taxnumber?: string,
        public idnumber?: string,
        public occupation?: string) { }
}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/classes/user-data.class.ts